import { Skeleton } from "@/components/ui/skeleton";

export const LoginSkeleton = () => {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div
        className="hidden lg:block"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 20% 10%, rgba(253,118,26,0.35), transparent 55%), #0f1626",
        }}
      />
      <div className="flex items-center justify-center p-8 bg-[oklch(0.97_0.005_250)]">
        <div className="w-full max-w-[400px] space-y-4">
          <Skeleton className="w-40 h-8" />
          <Skeleton className="w-full h-10" />
          <Skeleton className="w-4/5 h-4" />
          <div className="rounded-xl border border-border bg-card p-6 space-y-4">
            <Skeleton className="w-full h-9" />
            <Skeleton className="w-full h-9" />
            <Skeleton className="w-full h-9" />
            <Skeleton className="w-full h-9" />
            <Skeleton className="w-full h-11" />
          </div>
        </div>
      </div>
    </div>
  );
};
